module.exports = __webpack_public_path__ + "static/media/workbg-krx.8e379602.jpg";